<template>
  <div>
    <v-switch
      :color="color"
      :label="labelFilter"
      :append-icon="postIcon"
      :prepend-icon="preIcon"
      v-model="localValue"
      :class="classes['switch']"
      :style="localStyle['switch']"
    >
    </v-switch>
  </div>
</template>

<script>
import emittable from "../../../mixins/emittable";

import { VSwitch } from 'vuetify/lib'

export default {
  name: "FilterBoolean",
  components: {
    VSwitch
  },
  mixins: [emittable],
  data: function () {
    let ls = {...this.styles}

    if(!ls['switch'])
      ls['switch'] = {}

    // if(!ls['switch']['width'])
    //   ls['switch']['width'] = 'red';

    return {
      localValue: this.value,
      localStyle: ls
    };
  },
  props: {
    labelFilter: {
      type: String,
      default: "Active",
    },
    value: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "primary",
    },
    postIcon: {
      type: String,
      default: undefined,
    },
    preIcon: {
      type: String,
      default: undefined,
    },
    styles: {
      type: Object,
      default: function () {
        return {
          switch:{}
        };
      },
    },
    classes: {
      type: Object,
      default: function () {
        return {
          switch: {},
        };
      },
    },
  },
  watch: {
    localValue(val) {
      this.emit("input", val);
      this.emit("change", val);
    },
    value(val) {
      if (val !== this.localValue) this.localValue = val;
    },
  },
};
</script>

<style>
</style>